import React from "react";
import { createBrowserRouter, createRoutesFromElements, RouterProvider, Route } from "react-router-dom";
import "./styles.css";
import { LeftNav, Login } from "./components";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export default function Root() {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <>
        <Route path="/login" element={<Login />} errorElement={<>Error loading login page</>} />
        <Route path="/*" element={<LeftNav />} errorElement={<>Error loading nav bar</>} />
      </>
    )
  );

  const queryClient = new QueryClient();

  return (
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </React.StrictMode>
  );
}
